/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { GroupDiscussionPhotoRequest } from '../models/GroupDiscussionPhotoRequest';
import { HttpFile } from '../http/http';

export class CreateGroupDiscussionRequest {
    'title': string;
    'body': string;
    'mainPhoto'?: GroupDiscussionPhotoRequest;
    'isDraft'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "body",
            "baseName": "body",
            "type": "string",
            "format": ""
        },
        {
            "name": "mainPhoto",
            "baseName": "mainPhoto",
            "type": "GroupDiscussionPhotoRequest",
            "format": ""
        },
        {
            "name": "isDraft",
            "baseName": "isDraft",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return CreateGroupDiscussionRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

